<template>
  <div class="layout-vertical-center">
    <el-card style="min-width: 552px;">
      <template #header>{{ $t('reset.title') }}</template>
      <div style="margin-bottom: 42px;">
      </div>
      <el-form
        ref="refForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        @keyup.enter="handleResetPassword"
        @submit.prevent
      >
        <el-form-item
          :label="$t('reset.new_password')"
          prop="password"
        >
          <el-input
            v-model="formData.password"
            :type="newPasswordInput ? 'password' : 'text'"
            placeholder="Password"
          >
            <template #append>
              <div
                role="button"
                class="pointer"
                @click="newPasswordInput = !newPasswordInput"
              >
                <i :class="newPasswordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('reset.c_new_password')"
          prop="password_confirmation"
        >
          <el-input
            v-model="formData.password_confirmation"
            :type="c_newPasswordInput ? 'password' : 'text'"
            placeholder="Password"
          >
            <template #append>
              <div
                role="button"
                class="pointer"
                @click="c_newPasswordInput = !c_newPasswordInput"
              >
                <i :class="c_newPasswordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="btn-full-block"
            @click="handleResetPassword"
          >
            {{ $t('reset.button_reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const store = useStore()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const refForm = ref(null)
const formData = reactive({
  email: '',
  token: '',
  password: '',
  password_confirmation: ''
})
const newPasswordInput = ref(true)
const c_newPasswordInput = ref(true)
const rules = reactive({
  password: [{ required: true, trigger: 'blur' }],
  password_confirmation: [{ required: true, trigger: 'blur' }]
})
const handleResetPassword = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      const email = route.query.email.split('?')
      const token = route.query.token.split('?')
      formData.email = email[0]
      formData.token = token[0]
      store.dispatch('app/fetchResetPassword', formData).then((response) => {
        ElMessage({
          type: 'success',
          message: t('reset.reset_success')
        })
        loading.value = false
        router.push({
          path: '/login'
        })
      }).catch((error) => {
        ElMessage({
          type: 'error',
          message: error.string
        })
        loading.value = false
      })
    } else {
      ElMessage({
        type: 'warning',
        message: t('warning.complete_the_data')
      })
      loading.value = false
      return false
    }
  })
}
</script>
